import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, relationExportList } from "@/api/PMS/baseInformation/house";
import { fetchListByType } from "@/api/PMS/dic/dic";
import waves from "@/directive/waves"; // 水波纹指令

import houseAdd from "./add";
import renting from "./renting";
import houseDetail from "./detail";
import houseCustom from "./customer";
import houseHistory from "./history";
import houseCustomerList from "./customerList"; // 导入弹出框

import importExcel from "./import"; // 导入

import { formatJson } from "@/utils/index"; // 人房

import relaImportExcel from "./relaImport";
export default {
  components: {
    houseAdd: houseAdd,
    renting: renting,
    houseDetail: houseDetail,
    houseCustom: houseCustom,
    houseCustomerList: houseCustomerList,
    houseHistory: houseHistory,
    importExcel: importExcel,
    relaImportExcel: relaImportExcel
  },
  directives: {
    waves: waves
  },
  props: ["routerIdArr", "id", "flagId", "activeName", "isInitSearch"],
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        buildingName: "",
        houseCode: "",
        houseType: "",
        houseStatus: ""
      },
      title: "",
      dialogCustomerListVisible: false,
      houseId: [],
      typeOption: [],
      stateOption: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogRentingFormVisible: false,
      dialogDetailVisible: false,
      dialogCustomerVisible: false,
      dialogHistoryVisible: false,
      exlist: [],
      dialogExcelVisible: false,
      relationlist: [],
      excelVisible: false
    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
    this.loadRoomType();
    this.loadRoomState();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var houseIds = [];
      this.multipleSelection.forEach(function (row) {
        houseIds.push(row.houseId);
      });
      this.delete(houseIds);
    },
    handCancle: function handCancle(reload) {
      this.getList();
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");

      switch (reload) {
        case true:
          this.dialogFormVisible = false;
          this.dialogCustomerVisible = false;
          this.dialogCustomerListVisible = false;
          this.dialogRentingFormVisible = false;
          break;

        case "offCustomer":
          this.dialogCustomerVisible = false;
          break;

        case "offCustomerList":
          this.dialogCustomerListVisible = false;
          break;

        case "offHouseEdit":
          this.dialogFormVisible = false;

        case "renting":
          this.dialogRentingFormVisible = false;
          break;
      }
    },
    // handCancleRenting(reload) {
    //   console.log('///000');
    //   this.getList();
    //   this.dialogRentingFormVisible = false;
    // },
    handDetailCancle: function handDetailCancle(data) {
      this.getList();
      this.dialogDetailVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.buildingName = "";
        this.listQuery.houseCode = "";
        this.listQuery.houseType = "";
        this.listQuery.houseStatus = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    getItemDetail: function getItemDetail(houseId) {
      this.houseId = houseId;
      this.title = "详情";
      this.dialogFormVisible = true;
      this.isDetail = true;
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    loadRoomType: function loadRoomType() {
      var _this2 = this;

      fetchListByType("house_type").then(function (r) {
        _this2.typeOption = r.data.data;
      });
    },
    loadRoomState: function loadRoomState() {
      var _this3 = this;

      fetchListByType("house_status").then(function (r) {
        _this3.stateOption = r.data.data;
      });
    },
    // 创建
    handleCreate: function handleCreate() {
      this.houseId = "";
      this.title = "添加";
      this.dialogFormVisible = true;
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");
    },
    // 退租
    handleRenting: function handleRenting() {
      this.houseId = "";
      this.title = "办理退租";
      this.dialogRentingFormVisible = true;
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");
    },
    // 编辑
    handleUpdate: function handleUpdate(houseId) {
      this.houseId = houseId;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    // 详情
    handleDetails: function handleDetails(houseId) {
      this.houseId = houseId;
      this.title = "详情";
      this.dialogDetailVisible = true;
    },
    // 绑定业主
    changeProprietor: function changeProprietor(houseId) {
      this.houseId = houseId;
      this.title = "绑定业主";
      this.dialogCustomerVisible = true;
    },
    // 绑定住户
    changeCustomerList: function changeCustomerList(houseId) {
      this.houseId = houseId;
      this.title = "绑定住户";
      this.dialogCustomerListVisible = true;
    },
    // 绑定业主历史记录
    changeProprietorHis: function changeProprietorHis(houseId) {
      this.houseId = houseId;
      this.title = "绑定业主历史记录";
      this.dialogHistoryVisible = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(houseIds) {
      var _this4 = this;

      if (houseIds.length > 0) {
        this.$confirm("你确定是要删除这些房屋信息, 是否继续?", "提示").then(function () {
          fetchDelete(houseIds).then(function (res) {
            if (res.data.code === 200) {
              _this4.getList();

              _this4.$emit("refreshTree");

              _this4.$emit("loadMenuTab");

              _this4.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(houseId) {
      var houseIds = [];
      houseIds.push(houseId);
      this.delete(houseIds);
    },
    handleExport: function handleExport() {
      var _this5 = this;

      var exQuery = {
        buildingName: this.listQuery.buildingName,
        houseCode: this.listQuery.houseCode,
        houseType: this.listQuery.houseType,
        houseStatus: this.listQuery.houseStatus,
        id: this.listQuery.id,
        dataType: this.listQuery.dataType
      };
      fetchList(exQuery).then(function (response) {
        // response.data.data.forEach((v, index) => {
        //   _this.exList.push({
        //     indexs: index + 1,
        //     areaGroupName: v.areaGroupName,
        //     buildingName: v.buildingName,
        //     unintName: v.unintName,
        //     houseCode: v.houseCode,
        //     houseTypeName: v.houseTypeName,
        //     houseStatusName: v.houseStatusName,
        //     houseArea: v.houseArea,
        //     houseUseArea: v.houseUseArea,
        //   });
        // });
        _this5.exlist = response.data.data;

        _this5.$nextTick(function () {
          _this5.$confirm("你确定要导出房屋数据吗, 是否继续?", "提示").then(function () {
            if (_this5.exlist !== null && _this5.exlist.length > 0) {
              Promise.resolve().then(function () {
                return _interopRequireWildcard(require("@/vendor/Export2Excel"));
              }).then(function (excel) {
                var tHeader = [// "序号",
                "管理区域", "楼栋", "单元名称", "房屋代码", "层数", "使用性质", "房屋状态", "房间数量", "建筑面积（㎡）", "使用面积（㎡）"];
                var fileterVal = [// "indexs",
                "areaGroupName", "buildingName", "unintName", "houseCode", "floorNumber", "houseTypeName", "houseStatusName", "roomNum", "houseArea", "houseUseArea"];
                var data = formatJson(fileterVal, _this5.exlist);
                excel.export_json_to_excel({
                  header: tHeader,
                  data: data,
                  filename: "房屋数据",
                  autoWidth: true,
                  bookType: "xlsx"
                });
              });
            } else {
              _this5.Alert({
                alertType: "error",
                message: "暂无数据，无法导出！"
              });
            }
          });
        });
      });
    },
    // 导入
    handleUpload: function handleUpload() {
      this.title = "导入Excel";
      this.dialogExcelVisible = true;
    },
    excelCancle: function excelCancle(reload) {
      this.dialogExcelVisible = false;
      this.excelVisible = false;

      if (reload) {
        this.getList();
        this.$emit("refreshTree");
        this.$emit("loadMenuTab");
      }
    },
    // 人房关系导入
    relationUpload: function relationUpload() {
      this.title = "人房关系导入Excel";
      this.excelVisible = true;
    },
    // 人房关系导出
    relationExportBtn: function relationExportBtn() {
      var _this6 = this;

      relationExportList().then(function (response) {
        _this6.relationlist = response.data.data;

        _this6.$nextTick(function () {
          _this6.$confirm("你确定要导出人房关系数据吗, 是否继续?", "提示").then(function () {
            if (_this6.relationlist !== null && _this6.relationlist.length > 0) {
              Promise.resolve().then(function () {
                return _interopRequireWildcard(require("@/vendor/Export2Excel"));
              }).then(function (excel) {
                var tHeader = ["楼栋名称", "单元名称", "房屋名称", "人员身份", "人员姓名", "11位手机号码"];
                var fileterVal = ["buildingName", "unintName", "houseCode", "lvZhlxName", "customerName", "customerPhone"];
                var data = formatJson(fileterVal, _this6.relationlist);
                excel.export_json_to_excel({
                  header: tHeader,
                  data: data,
                  filename: "人房关系",
                  autoWidth: true,
                  bookType: "xlsx"
                });
              });
            } else {
              _this6.Alert({
                alertType: "error",
                message: "暂无数据，无法导出！"
              });
            }
          });
        });
      });
    }
  }
};